import script from "./Communication.vue?vue&type=script&setup=true&lang=js"
export * from "./Communication.vue?vue&type=script&setup=true&lang=js"

import "./Communication.vue?vue&type=style&index=0&id=289eeeca&lang=css"

const __exports__ = script;

export default __exports__